module.exports = __webpack_public_path__ + "img/player_button.7abd7e68.png";